// extracted by mini-css-extract-plugin
module.exports = {"header":"SubHeader_header__VlqdS","heading":"SubHeader_heading__3y37G"};